import AddCriteria from "../../features/CRUD/crudCriteriaList/Components/addCriteria/AddCriteria"

const AddCriteriaPage  = () => {
  return (
    <div>
      <AddCriteria />
    </div>
  )
}

export default AddCriteriaPage
